import { IconButton, Paper, Stack, Typography } from "@mui/material";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

type TChatHeaderProps = { isEscalated: boolean; title: string; toggleOpenChat: () => void; closeChat: () => void };

const ChatHeader = (props: TChatHeaderProps) => {
	const { isEscalated, title, toggleOpenChat, closeChat } = props;
	return (
		<Paper
			elevation={0}
			className="!bg-primary"
			sx={{
				paddingLeft: "15px",
				height: "50px",
				position: "relative",
				marginTop: "-8px",
				borderRadius: "10px 10px 0px 0px",
				paddingTop: "10px",
				borderBottom: "1px solid #ffffff",
			}}
		>
			<Stack direction="row" spacing={1}>
				<Typography className="chat-header-text">{isEscalated ? `(Escalated) ${title}` : title}</Typography>
				<IconButton
					aria-label="close"
					size="small"
					className="main-add-section-min-btn"
					sx={{ color: "white" }}
					onClick={toggleOpenChat}
				>
					<RemoveRoundedIcon fontSize="inherit" />
				</IconButton>
				<IconButton aria-label="delete" size="small" className="chat-close-btn" sx={{ color: "white" }} onClick={closeChat}>
					<CloseRoundedIcon fontSize="inherit" />
				</IconButton>
			</Stack>
		</Paper>
	);
};

export default ChatHeader;
